<template>
  <div class="container">
    <!-- <el-form ref="searchForm" :model="searchData" inline>
      <el-form-item label="id">
        <el-input v-model.number="searchData.id" size="mini" />
      </el-form-item>
      <el-form-item>
        <el-button size="mini" @click="handleSearch">
            查找
        </el-button>
      </el-form-item>
    </el-form> -->

    <div class="head">
      <el-button type="primary" @click="handleAdd" size="small">添加团队</el-button>
    </div>

    <el-table
      :data="data"
      @sort-change="handlerSort"
      :default-sort = "{prop: 'id', order: 'descending'}"
    >
      <el-table-column
        prop="id"
        label="ID"
      />

      <el-table-column
        prop="name"
        label="名称"
      />

      <el-table-column
        prop="customer"
        label="客户"
      />

      <el-table-column
        prop="quota"
        label="配额"
      />

      <el-table-column
        prop="status"
        label="状态"
        :formatter="(_, _1, v) => { return getStatusName(v) }"
      />

      <el-table-column
        label="操作"
      >
        <template slot-scope="scope">
          <el-button size='mini' type="primary" @click="handleSetQuota(scope.row)"> 设置配额 </el-button>
          <el-button v-if="scope.row.status !== 0" size='mini' type="primary" @click="handleEnable(scope.row)"> 启用 </el-button>
          <el-button v-else size='mini' type="danger" @click="handleDisable(scope.row)"> 禁用 </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pager
      ref="pager"
      api="team_list"
      :filter="filter"
      :sort="sort"
      model="cs"
      @data-changed="onDataChanged"
    />

    <el-dialog 
      title="新增团队"
      :visible.sync="showEditForm"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleEditFormDialogClose"
    >

      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right">
        
        <el-form-item prop="name" label="名称:" label-width="150px">
          <el-input v-model="editForm.name" style="width:50%" />
        </el-form-item>

      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditForm = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveAdd">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog 
      title="设置配额"
      :visible.sync="showEditQuota"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleEditQuotaDialogClose"
    >

      <el-form ref="editQuotaForm" :model="editQuotaForm" :rules="editRules" label-position="right">
        
        <el-form-item prop="quota" label="配额:" label-width="150px">
          <el-input-number v-model="editQuotaForm.quota" style="width:50%" />
        </el-form-item>

      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditQuota = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveSetQuota">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import Pager from "../ui/Pager"
  import request from "@/api/request"

  const initForm = {
    name: null
  }

  const initQuotaForm = {
    id: null,
    quota: null
  }
  export default {
    name: 'TameList',
    components: { Pager },
    data () {
      return {
        searchData: {},
        data: [],
        filter: {},
        sort: [],
        editForm: { ...initForm },
        editQuotaForm: { ...initQuotaForm },
        editRules: {
          name: [
            {
              required: true,
              message: "名称不能为空"
            }
          ]
        },
        showEditForm: false,
        showEditQuota: false
      }
    },
    computed: {
    
    },
    methods: {
      onDataChanged: function (data) {
        this.data = data
      },
      handleSearch() {
        let filter = {}
        this.filter = filter
      },
      handleAdd() {
        this.editForm = { ...initForm }
        this.showEditForm = true
      },
      handleSaveAdd() {
        this.$refs.editForm.validate(async valid => {
          if (valid) {
            this.$refs.editForm.clearValidate()
            
            await request.cs
              .post("team_create", this.editForm)
              .then(() => {
                this.$message.success("添加成功")
              })
            this.showEditForm = false;
            this.$refs.pager.loadData()
          }
        })
      },
      handleSaveSetQuota() {
          this.$refs.editQuotaForm.validate(async valid => {
          if (valid) {
            this.$refs.editQuotaForm.clearValidate()
            
            await request.cs
              .post("team_quota_set", this.editQuotaForm)
              .then(() => {
                this.$message.success("设置成功")
              })

            this.showEditQuota = false;
            this.$refs.pager.loadData()
          }
        })
      },
      handleEnable(row) {
        this.$confirm(`确定启用 ID 为 ${row.id} 的团队`)
          .then(() => {
            this.updateStatus(row.id, 0)
          })
      },
      handleDisable(row) {
        this.$confirm(`确定禁用 ID 为 ${row.id} 的团队`)
          .then(() => {
            this.updateStatus(row.id, 900)
          })
      },
      handleSetQuota(row) {
        this.editQuotaForm.id = row.id
        this.editQuotaForm.quota = row.quota
        this.showEditQuota = true
      },
      handleEditFormDialogClose() {
        this.$refs.editForm.resetFields()
        this.$refs.editForm.clearValidate()
      },
      handleEditQuotaDialogClose() {
        this.$refs.editQuotaForm.resetFields()
        this.$refs.editQuotaForm.clearValidate()
      },
      handlerSort(column) {
        this.sort = [
          {
            field: column.prop,
            reverse: column.order === 'descending'
          }
        ]
      },
      updateStatus(id, status) {
        request
            .cs
            .post("team_status_update", {
                id: id,
                status: status
            }).then(() => {
                this.$message.success('操作成功')
                this.$refs.pager.loadData()
            }).catch(data => {
                this.$message.error(data.err)
            })

      },
      getStatusName(key) {
        return key === 0 ? '启用' : '禁用'
      }
    }
  }
</script>
